import { useRef } from 'react'

import { toAsyncSelectLocalPage } from './useAsyncSelectLocalData.utils'

// Serves a dictionary the backend returns whole to an async select: one request
// per `key`, then the search and the pages are cut from the loaded options
export function useAsyncSelectLocalData({ getOptions, key }) {
  const requestRef = useRef(null)

  function getOptionsRequest() {
    if (!requestRef.current || requestRef.current.key !== key) {
      requestRef.current = {
        key,
        promise: getOptions().catch(error => {
          if (requestRef.current?.key === key) {
            requestRef.current = null
          }

          throw error
        }),
      }
    }

    return requestRef.current.promise
  }

  async function getData({ page, search }) {
    return getOptionsRequest().then(options =>
      toAsyncSelectLocalPage({ options, page, search })
    )
  }

  return { getData }
}
